export const isMobileMedia = () =>
  window.matchMedia("(max-width: 768px)").matches;
